import { useState } from "react";
import css from "./Archive.module.css";
import Modal from "../Modals/Modal/Modal.jsx";
import { BsArchive } from "react-icons/bs";
import ArchiveInfoModal from "./ArchiveInfoModal/ArchiveInfoModal.jsx";
import useTooltip from "../../utils/useTooltip.jsx";
import Tooltip from "../sharedComponents/Tooltip/Tooltip.jsx";
import { useTour } from "@reactour/tour";

export default function Archive() {
  const [modalIsOpen, setIsOpen] = useState(false);
  const { setCurrentStep, currentStep } = useTour();

  const openModal = () => {
    setIsTooltipVisible(false);
    setIsOpen(true);
    setCurrentStep(currentStep + 1);
  };

  const handleModalClose = () => {
    setIsOpen(false);
    setCurrentStep(currentStep + 1);
  };

  const {
    tooltipPosition,
    isTooltipVisible,
    setIsTooltipVisible,
    handleMouseEnter,
    handleMouseMove,
    handleMouseLeave,
    handleClick,
  } = useTooltip();

  return (
    <div
      className={css.tooltip}
      onMouseEnter={handleMouseEnter}
      onMouseMove={handleMouseMove}
      onMouseLeave={handleMouseLeave}
      onClick={handleClick}
    >
      <button
        className={css.btn}
        onClick={openModal}
        data-tour-carslist="step-3.4"
      >
        <BsArchive className={css.icon} />
      </button>
      {modalIsOpen && (
        <Modal isOpen={modalIsOpen} onClose={handleModalClose}>
          <ArchiveInfoModal onClose={handleModalClose} />
        </Modal>
      )}

      {isTooltipVisible && !modalIsOpen && (
        <Tooltip
          isVisible={isTooltipVisible}
          position={tooltipPosition}
          text="Архів"
        />
      )}
    </div>
  );
}
